import { FireTvModel } from "./FireTv.model";

export class FireTv extends FireTvModel {
    // Add custom methods here
}
